<script>
import Component from '~/sites/cvb/pages/product/_slug'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/produkt/:slug',
      de: '/produkt/:slug',
      en: '/product/:slug',
      sk: '/produkt/:slug',
    },
  },
}
</script>
